const dayjs = require('dayjs');
const propIsNull = (value) => {
  return (
    value === null ||
    value === '' ||
    value === undefined ||
    (Array.isArray(value) && value.length === 0)
  );
};

const getDefaultValue = (propInfo, createTime, creator, userId) => {
  if (propInfo.type === 'user' && propInfo.defaultValue) {
    if (propInfo.defaultValue === 'creator') {
      // 创建者
      return propInfo.multiple ? [creator] : creator;
    } else if (propInfo.defaultValue === 'updater') {
      // 更新者
      return userId && propInfo.multiple ? [userId] : userId;
    } else {
      // 用户id
      return propInfo.multiple ? [propInfo.defaultValue] : propInfo.defaultValue;
    }
  }
  if ((propInfo.type === 'datetime' || propInfo.type === 'date') && propInfo.defaultValue) {
    if (propInfo.defaultValue === 'createTime') {
      return createTime && Number.isFinite(createTime)
        ? dayjs(createTime.toString().length === 13 ? createTime : createTime * 1000).valueOf()
        : dayjs().valueOf();
    } else if (propInfo.defaultValue === 'updateTime') {
      return dayjs().valueOf();
    }
  }
  if ((propInfo.type === 'tag' || propInfo.type === 'enum') && propInfo.defaultValue) {
    return propInfo.multiple ? [propInfo.defaultValue] : propInfo.defaultValue;
  }
  if (
    (propInfo.type === 'number' || propInfo.type === 'currency') &&
    !propIsNull(propInfo.defaultValue) &&
    Number.isFinite(Number(propInfo.defaultValue))
  ) {
    return Number(propInfo.defaultValue);
  }
  return null;
};

/**
 * 处理条件匹配
 * @param handleDataIndex 当前操作的属性index
 * @param propData 当前的属性数据
 * @param userMap 用户信息map { userid:{ nick_name:xxxx } }
 * @param template 当前模板
 * @param templateList 空间模板列表
 * @param matchConfig 可选，已经通过getConditionMatchProps匹配的数据
 * @param {string} creator 创建者
 * @param title 标题
 * @param changedFields 被修改的属性
 * @param createTime 节点创建时间
 * @param currentUserId 当前操作用户ID
 * @returns {[undefined,*[]]}
 */
const conditionMatchPropsData = ({
  handleDataIndex,
  propData,
  userMap,
  template,
  templateList = null,
  matchConfig,
  creator = '',
  title = '',
  changedFields = [],
  createTime = 0,
  currentUserId = '',
}) => {
  // 当前编辑的字段，是否是其他属性的匹配规则
  // matchingType < 0 不参与条件匹配设置值
  if (!matchConfig) return [propData, changedFields];
  const fields = {};
  matchConfig
    .filter((x) => ~x.matchingIndex.indexOf(handleDataIndex))
    .map((config) => {
      if (
        (~changedFields.indexOf(config.index) && !propIsNull(propData[config.index])) ||
        template.prop[config.index]?.matchingType < 0
      )
        return;
      const curDataValues = config.matchingIndex.map((propIndex, i) => {
        if (propIndex < 0) {
          if (propIndex === -1) {
            //创建人
            return creator;
          } else if (propIndex === -3) {
            //标题
            return title;
          } else {
            return null;
          }
        } else {
          if (template.prop[propIndex]?.type === 'cascade') {
            if (template.prop[config.index]?.conditionCascade?.[i]?.condition) {
              const prefix = template.prop[config.index]?.conditionCascade?.[i]?.condition + '-';
              return (
                propData[propIndex]?.filter((v) => typeof v === 'string' && v.startsWith(prefix)) ||
                null
              );
            } else {
              return null;
            }
          }
          return typeof propData[propIndex] === 'number'
            ? propData[propIndex].toString()
            : propData[propIndex];
        }
      });
      const matchingValues = config.matchingValues.filter((x) => {
        if (
          Array.isArray(x.key) &&
          x.key.length === curDataValues.length &&
          !~x.key.findIndex((y) => !y) &&
          !~curDataValues.findIndex((z) => !z)
        ) {
          let isMatch = true;
          for (let index = 0; index < x.key.length; index++) {
            const key = x.key[index];
            const curDataValue = curDataValues[index];
            if (curDataValue === key) continue;
            if (Array.isArray(key)) {
              if (
                (Array.isArray(curDataValue) && !curDataValue.find((z) => !~key.indexOf(z))) ||
                ~key?.indexOf(curDataValue)
              )
                continue;
            } else if (
              Array.isArray(curDataValue) &&
              curDataValue.length === 1 &&
              curDataValue[0] === key
            ) {
              continue;
            }
            isMatch = false;
            break;
          }
          return isMatch;
        }
        return false;
      });
      const matchPropInfo = template.prop[config.index];
      if (!matchingValues.length || !Array.isArray(matchingValues[0].prop)) {
        const defaultValue = getDefaultValue(matchPropInfo, createTime, creator, currentUserId);
        if (!propIsNull(defaultValue)) {
          // 匹配不到值时，优先写入默认值
          fields[config.index] = defaultValue;
        } else if (!propIsNull(propData[config.index])) {
          // 匹配不到值时，清空已经填进去的值或之前匹配到的值
          fields[config.index] = null;
        } else {
          return;
        }
      } else {
        const matchData = matchingValues[0].prop;
        if (matchPropInfo.matchingType === 5) {
          let fieldValue = 0;
          matchingValues.forEach((m) => {
            if (m.prop[0]?.type === 'number') {
              const mv = Array.isArray(m.prop[0].value) ? m.prop[0].value[0] : m.prop[0].value;
              if (!propIsNull(mv) && Number.isFinite(Number(mv))) {
                fieldValue += Number(mv);
              }
            }
          });
          fields[config.index] =
            matchPropInfo.type === 'number' || matchPropInfo.type === 'currency'
              ? fieldValue
              : fieldValue.toString();
        } else {
          // 人员 或 选值 或 引用
          if (
            matchPropInfo.type === 'user' ||
            matchPropInfo.type === 'enum' ||
            matchPropInfo.type === 'tag'
          ) {
            let checkValue = propData[config.index],
              value;
            const matchType = matchPropInfo.type;
            if (matchPropInfo.multiple) {
              // 多选
              value = [];
              matchData
                .filter((x) => !propIsNull(x.value))
                .map((x) => {
                  if (Array.isArray(x.value)) {
                    x.value?.map((id) => {
                      if (!~value.indexOf(id)) {
                        value.push(id);
                      }
                    });
                  } else {
                    value.push(x.value);
                  }
                });
            } else {
              if (Array.isArray(checkValue)) checkValue = checkValue.length ? checkValue[0] : null;
              if (checkValue) {
                if (
                  matchData.find((x) => ~x.value.indexOf(checkValue)) ||
                  (Array.isArray(matchingValues[0].alternatives) &&
                    matchingValues[0].alternatives.find((a) => {
                      return Array.isArray(a) && a.find((x) => ~x.value.indexOf(checkValue));
                    }))
                )
                  return;
              }
              // 单选 只取第一个
              value = matchData.find((x) => !propIsNull(x.value))?.value || null;
              if (Array.isArray(value)) {
                value = value.length ? value[0] : null;
              }
            }
            fields[config.index] = value;
          } else if (matchPropInfo.type === 'quote') {
            // 2022/9/26 引用属性全走后端的实时同步
            // // 取matchData[0]
            // if (matchData[0]?.type === 'quote') {
            //   let value = matchData[0].value;
            //   if (value) {
            //     fields[config.index] = value;
            //   } else if (matchData[0].id && matchData[0].props) {
            //     fields[config.index] = {
            //       id: matchData[0].id,
            //       props: matchData[0].props,
            //     };
            //   }
            // }
          } else if (matchPropInfo.type === 'text') {
            //  文本,都拿实际的值 用-分割
            fields[config.index] = matchData
              .filter((x) => !!x.value)
              .map((item) => {
                if (
                  item.value === null ||
                  (Array.isArray(item.value) && !item.value.find((iv) => !!iv))
                ) {
                  return '未填写';
                }
                if (item.type === 'datetime') {
                  return dayjs(item.value).format('YYYY/MM/DD HH:mm');
                }
                if (item.type === 'date') {
                  return dayjs(item.value).format('YYYY/MM/DD');
                }
                if ((item.type === 'tag' || item.type === 'enum') && Array.isArray(item.value)) {
                  return item.value?.join('-');
                }
                if (item.type === 'user') {
                  if (Array.isArray(item.value)) {
                    return item.value
                      .map((id) => {
                        return userMap[id]?.nick_name || '未知用户';
                      })
                      .join('-');
                  } else {
                    return userMap[item.value]?.nick_name || '未知用户';
                  }
                }
                return item.value;
              })
              .join('-');
          } else if (matchPropInfo.type === 'number' || matchPropInfo.type === 'currency') {
            // if (matchData[0]?.type === 'number' || matchData[0]?.type === 'currency') {
            const mv = Array.isArray(matchData[0].value)
              ? matchData[0].value[0]
              : matchData[0].value;
            if (!propIsNull(mv) && Number.isFinite(Number(mv))) {
              fields[config.index] = Number(mv);
            }
            // }
          } else if (matchPropInfo.type === 'cascade') {
            // 引用多级属性
            // 字符串转string[]
            try {
              fields[config.index] = matchData[0].value[0].split(',');
            } catch (error) {}
          }
        }
      }
      // if (!propIsNull(fields[config.index])) propData[config.index] = fields[config.index];
      propData[config.index] = propIsNull(fields[config.index]) ? null : fields[config.index];
    });
  if (Object.keys(fields).length) {
    Object.keys(fields).map((field) => {
      field = parseInt(field);
      // propData[field] = fields[field];
      changedFields.push(field);
    });
    Object.keys(fields).map((field) => {
      field = parseInt(field);
      [propData, changedFields] = conditionMatchPropsData({
        handleDataIndex: field, // 当前操作的属性index
        propData, // 当前的属性数据
        userMap, // 用户信息map { userid:{ nick_name:xxxx } }
        template, // 当前模板
        templateList, // 空间模板列表
        matchConfig, // 可选，已经通过getConditionMatchProps匹配的数据
        creator, //创建者
        title,
        changedFields,
        createTime,
        currentUserId,
      });
    });
  }
  return [propData, changedFields];
};

module.exports = conditionMatchPropsData;
